import React, { useState } from "react";
import { Container, Row, Col, Form, Button, Alert } from "react-bootstrap";
import { FaEnvelope, FaPhoneAlt, FaMapMarkerAlt, FaUser } from "react-icons/fa";

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    setTimeout(() => setSubmitted(false), 3000); // Hide alert after 3s
  };

  return (
    <Container className="py-5">
      <Row className="justify-content-center">
        <Col md={8} lg={6} className="text-center">
          <h2 className="mb-4">Get in Touch</h2>
          <p className="text-muted">We'd love to hear from you! Send us a message.</p>
        </Col>
      </Row>

      <Row className="justify-content-center">
        <Col md={6}>
          {submitted && <Alert variant="success">Message sent successfully!</Alert>}

          <Form onSubmit={handleSubmit} className="p-4 border rounded shadow-sm bg-light">
            <Form.Group className="mb-3">
              <Form.Label><FaUser className="me-2" />Name</Form.Label>
              <Form.Control
                type="text"
                name="name"
                placeholder="Enter your name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label><FaEnvelope className="me-2" />Email</Form.Label>
              <Form.Control
                type="email"
                name="email"
                placeholder="Enter your email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label><FaMapMarkerAlt className="me-2" />Message</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                name="message"
                placeholder="Your message..."
                value={formData.message}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Button variant="primary" type="submit" className="w-100">
              Send Message 🚀
            </Button>
          </Form>
        </Col>

        {/* Contact Info Section */}
        <Col md={6} className="d-flex flex-column align-items-start mt-4 mt-md-0">
          <div className="d-flex align-items-center mb-3">
            <FaMapMarkerAlt size={24} className="text-danger me-3" />
            <span>51, opp. Ajanta Transport, Mahaveer Nagar, Vakhar Bhag, Sangli, Sangli Miraj Kupwad, Maharashtra 416416</span>
          </div>
          <div className="d-flex align-items-center mb-3 d-none">
            <FaPhoneAlt size={24} className="text-success me-3" />
            <span>+1 234 567 890</span>
          </div>
          <div className="d-flex align-items-center">
            <FaEnvelope size={24} className="text-primary me-3" />
            <span>support@teeblanka.com</span>
          </div>
        </Col>
      </Row>

      {/* Google Map Embed */}
      <Row className="justify-content-center mt-4">
        <Col md={8}>
          <div className="ratio ratio-16x9">
            <iframe
              title="Google Map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3151.83543450931!2d144.9559283155045!3d-37.81720974202171!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6ad65d43bf3c5d77%3A0x2a3f56f89c2c1b!2sMelbourne%2C+VIC%2C+Australia!5e0!3m2!1sen!2sin!4v1614319452217!5m2!1sen!2sin"
              width="600"
              height="450"
              allowFullScreen=""
              loading="lazy"
            ></iframe>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default ContactUs;
